// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#333","menuActiveText":"#f13d3d","subMenuActiveText":"#f13d3d","menuBg":"#fff","menuHover":"#fff","subMenuBg":"#fff","subMenuHover":"#f6f7f8","sideBarWidth":"240px"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/index.scss
// module id = N9P1
// module chunks = 39